const Notify = function (message, type, time) {
    if (!type) {
        type = "default";
    }
    if (!time) {
        time = 2000;
    }

    const $msg = $('<div class="aero-msg-' + type + '" style="display:none">' + message + '</div>');
    $('body').append($msg);

    $msg
        .css({
            'left': ($(window).width() / 2) - ($msg.outerWidth() / 2)
        })
        .fadeIn(750, function () {
            setTimeout(function () {
                $msg.fadeOut(500);
            }, time);
        });
};

export default Notify;